import React, { Fragment } from 'react'
import Header from '../component/Header'
import Banner from '../component/Banner'
import Noticias from '../component/Noticias'
import Footer from '../component/Footer'
import Empresasenvios from '../component/Empresasenvios'
function Inicio() {
  
    
    return (
        <Fragment>
                <Header />
                <section className="container-fluid mt-5" id="nosotros">

                    <div className='col-8 m-auto w__full'>
                        <h3 className='fw-light letra__'>Nosotros</h3>
                        <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            Quaerat vitae tempora recusandae. Aliquam quaerat eius vero deleniti,
                            doloribus nulla et minus cum voluptatibus totam eos repellendus
                            quibusdam nam eaque? Harum. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                            Quaerat vitae tempora recusandae. Aliquam quaerat eius vero deleniti,
                            doloribus nulla et minus cum voluptatibus totam eos repellendus
                            quibusdam nam eaque? Harum.
                        </p>
                    </div>
                </section>
            <div className='ontainer-fluid mt-5'>
                <div className='col-8 m-auto w__full'>
                    <Banner />
                 </div>
            </div>
            <section className="container-fluid mt-5" id="noticias">
                <div className='col-8 m-auto w__full'>
                    <h3 className='fw-light letra__'>Noticias</h3>
                    <Noticias />
                </div>
            </section>

            <Empresasenvios />
            <Footer />
        </Fragment>
    )
}

export default Inicio